import { Chain, EvmToken, ICToken, OdinToken, PlugToken, SolanaToken } from '../interfaces/common'

export const asICToken = (token: PlugToken): ICToken => {
  if (token.chain === Chain.ICP && token.address) {
    return token as ICToken
  } else {
    throw 'Provided token is not compatible with ICToken type'
  }
}

export const asOdinToken = (token: PlugToken): OdinToken => {
  if (token.chain === Chain.ODIN) {
    return token as OdinToken
  } else {
    throw 'Provided token is not compatible with OdinToken type'
  }
}

export const asSolanaToken = (token: PlugToken): SolanaToken => {
  if (token.chain === Chain.SOL) {
    return token as SolanaToken
  } else {
    throw 'Provided token is not compatible with SolanaToken type'
  }
}

export const asEvmToken = (token: PlugToken): EvmToken => {
  if (token.evmChain) {
    return token as EvmToken
  } else {
    throw 'Provided token is not compatible with EvmToken type'
  }
}
